import {
  Aside,
  Avatar,
  Badge, Breadcrumb,
  BreadcrumbItem,
  Button, Card,
  Checkbox,
  CheckboxGroup,
  Container,
  DatePicker,
  Descriptions,
  DescriptionsItem,
  Dialog, Divider, Dropdown,
  DropdownItem,
  DropdownMenu,
  Form,
  FormItem,
  Header, Image, Input,
  InputNumber,
  Link,
  Loading,
  Main,
  Menu,
  MenuItem,
  MenuItemGroup,
  Message,
  MessageBox,
  Option,
  Pagination,
  Progress,
  Radio,
  RadioButton,
  RadioGroup,
  Select,
  Submenu,
  Table,
  TableColumn,
  Tag,
  Timeline,
  TimelineItem,
  TimePicker,
  Tooltip, Tree, Upload
} from "element-ui";
import Vue from "vue";

Vue.use(Button);
Vue.use(Tag);
Vue.use(Image);
Vue.use(TimePicker);
Vue.use(Divider);
Vue.use(Tree);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Container);
Vue.use(Header);
Vue.use(Card);
Vue.use(Aside);
Vue.use(Main);
Vue.use(Menu);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Avatar);
Vue.use(Tooltip);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Badge);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(MenuItemGroup);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Checkbox);
Vue.use(Upload);
Vue.use(Timeline);
Vue.use(TimelineItem);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Pagination);
Vue.use(Dialog);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(CheckboxGroup);
Vue.use(Select);
Vue.use(DatePicker);
Vue.use(Option);
Vue.use(Loading);
Vue.use(Descriptions);
Vue.use(DescriptionsItem);
Vue.use(Link);
Vue.use(Progress);
Vue.use(RadioButton);
// // 为 Vue.prototype 添加了全局方法 $message。因此在 vue instance 中可以在所有页面中的方式调用 Message
Vue.prototype.$message = Message;
Vue.prototype.$loading = Loading;
Vue.prototype.$confirm = MessageBox.confirm;
